export const Colors = {
  Background: '#4a4f62',
  LightBackground: '#6e7386',
  Text: '#ffffff',
  Yellow: '#f0e31c',
}

export const TEXT_SHADOW = 'drop-shadow(0px 2px 1px rgba(0, 0, 0, 0.7))'
